import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Shirt = (props: SvgProps) => (
  <Svg width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
    <g clipPath="url(#clip0_1097_19277)" filter="url(#filter0_iin_1097_19277)">
      <path
        d="M20.9658 5.435L16.6525 3.08333C16.5548 3.02926 16.445 3.0006 16.3333 3H13.6667C13.4899 3 13.3203 3.07024 13.1953 3.19526C13.0702 3.32029 13 3.48986 13 3.66667C13 4.1971 12.7893 4.70581 12.4142 5.08088C12.0391 5.45595 11.5304 5.66667 11 5.66667C10.4696 5.66667 9.96086 5.45595 9.58578 5.08088C9.21071 4.70581 9 4.1971 9 3.66667C9 3.48986 8.92976 3.32029 8.80474 3.19526C8.67971 3.07024 8.51014 3 8.33333 3H5.66667C5.55469 3.00046 5.44464 3.02912 5.34667 3.08333L1.03417 5.435C0.72675 5.59746 0.496304 5.8752 0.393358 6.20731C0.290412 6.53943 0.323368 6.89881 0.484999 7.20667L2.09083 10.2742C2.20759 10.4947 2.38261 10.679 2.59684 10.807C2.81107 10.935 3.0563 11.0017 3.30583 11H5V17.6667C5 18.0203 5.14047 18.3594 5.39052 18.6095C5.64057 18.8595 5.97971 19 6.33333 19H15.6667C16.0203 19 16.3594 18.8595 16.6095 18.6095C16.8595 18.3594 17 18.0203 17 17.6667V11H18.695C18.9445 11.0017 19.1898 10.935 19.404 10.807C19.6182 10.679 19.7932 10.4947 19.91 10.2742L21.5158 7.20667C21.6774 6.89871 21.7102 6.53925 21.6071 6.20712C21.504 5.87499 21.2734 5.59732 20.9658 5.435ZM3.30583 9.66667C3.29352 9.66725 3.2814 9.66341 3.27167 9.65583L1.67417 6.605L5 4.79V9.66667H3.30583ZM18.7283 9.655C18.7237 9.65916 18.7183 9.66233 18.7124 9.66434C18.7066 9.66634 18.7004 9.66714 18.6942 9.66667H17V4.79L20.3267 6.605L18.7283 9.655Z"
        fill="url(#paint0_linear_1097_19277)"
      />
    </g>
    <defs>
      <filter
        id="filter0_iin_1097_19277"
        x="-0.895304"
        y="-0.417681"
        width="23.5522"
        height="22.8693"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.2288" dy="0.785067" />
        <feGaussianBlur stdDeviation="1.90123" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.937255 0 0 0 0 0.0980392 0 0 0 0 0.431373 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1097_19277"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.989867" dy="-0.750933" />
        <feGaussianBlur stdDeviation="2.97301" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.921569 0 0 0 0 0.501961 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_1097_19277"
          result="effect2_innerShadow_1097_19277"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="58.59375 58.59375"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="2877"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect2_innerShadow_1097_19277"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(239, 25, 110, 0.5)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect3_noise_1097_19277">
          <feMergeNode in="effect2_innerShadow_1097_19277" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <linearGradient
        id="paint0_linear_1097_19277"
        x1="21.6667"
        y1="0.0773336"
        x2="21.2049"
        y2="22.6816"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#274AE2" />
        <stop offset="0.466346" stopColor="#FFEB80" />
        <stop offset="1" stopColor="#EF196E" />
      </linearGradient>
      <clipPath id="clip0_1097_19277">
        <rect
          width="21.3333"
          height="21.3333"
          fill="white"
          transform="translate(0.333496 0.333252)"
        />
      </clipPath>
    </defs>
  </Svg>
);

export default Shirt;
